import { useEffect } from 'react';

import { useOpenSearchContext } from './useOpenSearchContext';

const DEFAULT_PAGE_SIZE = 20;

const useInfiniteHits = <T>() => {
  const {
    pageSize = DEFAULT_PAGE_SIZE,
    hits,
    updateSize,
    totalHits,
    isLoading,
    isFetching,
  } = useOpenSearchContext();
  const isLastPage = hits.length === totalHits;
  const hitsData = hits?.map(({ _source }) => _source as T);

  const loadMore = () => {
    updateSize((prev = pageSize) => prev + pageSize);
  };

  useEffect(() => {
    updateSize(pageSize);

    return () => {
      updateSize(undefined);
    };
  }, [pageSize]);

  return { hits: hitsData, isLastPage, loadMore, isLoading, isFetching };
};

export { useInfiniteHits };
